import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setErrors } from '../common/errorsSlice'
import { AppThunk } from '../store'
import { ModalEvent, requestPostModalEventLog } from '../../types/modalEvent'
import { getModalEventList, postModalEventLog } from '../../apis/modalEvent'
import { reject } from 'lodash'

interface ModalEventListState {
  modal_event: ModalEvent[]
  isLoading: boolean
}

const initialState: ModalEventListState = {
  modal_event: [],
  isLoading: false,
}

const modalEventListSlice = createSlice({
  name: 'modalEvent',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getModalEventListSuccess: (state, action: PayloadAction<{modal_events: ModalEvent[]}>) => {
      state.modal_event = action.payload.modal_events
      state.isLoading = false
      return state
    },
    deleteModalEventList: (state, action: PayloadAction<requestPostModalEventLog>) => {
      state.modal_event = reject(state.modal_event, { id: action.payload.modal_event_id })
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getModalEventListSuccess,
  deleteModalEventList,
  requestFailure,
} = modalEventListSlice.actions

export const modalEventListReducer = modalEventListSlice.reducer

export const fetchModalEventList = (): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getModalEventList()
    .then((result) => {
      dispatch(getModalEventListSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createModalEventLog = (
  params: requestPostModalEventLog,
): AppThunk => async (dispatch) => {
  postModalEventLog(params)
    .then(() => {
      dispatch(deleteModalEventList(params))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
